

















































































































































































import {Component} from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {Tabs, ScrollButton} from "wings-ui-components";
import {SmsDetailFilter} from '@/components/SMS';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { SmsDetailItem } from "@/store/sms/statistic/types";
import {dateFilter} from "@/utils/date-util";
import { colorClassByStatus } from "@/utils/page-utils";

@Component({
  components: {Tabs, SmsDetailFilter, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class SmsDetail extends BaseItemsPage<SmsDetailItem> {

  @Getter("smsStaticDetail") responseItems!: SmsDetailItem[];
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'create_date',
      'message',
      'originator',
      'partner',
      'recipient',
      'service_provider',
      'status',
      'message_category',
      'detail',
      'sms',
    ];
  }

  getData() {
    return this.responseItems;
  }

}
